import { addQueryParamsToUrl, navigate, validateUrl  } from '@healthhub/react-ui';
import { Typography } from 'antd';
import { useLocation, useNavigate } from 'react-router';

import { OutlinedRightArrowIcon } from '@shared/assets-icon';


const { Text } = Typography;

interface Props {
  fixedIcon?: string;
  icon?: string;
  link?: string;
  onClick?: () => void;
  title: string;
}

const MedicalItemCard = ({ fixedIcon, icon, link, onClick, title }: Props) => {
  const routerNavigate = useNavigate();
  const location = useLocation();

  const handleOnClick = () => {
    if (onClick) {
      onClick();
      return;
    }

    if (!link) return;

    if (validateUrl(link)) {
      navigate(link);
    } else {
      routerNavigate(addQueryParamsToUrl(link, { origin: `${location.pathname}${location.search}` }));
    }
  };

  return (
    <button
      className="flex cursor-pointer flex-row items-center gap-x-4 rounded-2xl bg-white p-4 text-start"
      onClick={handleOnClick}
    >
      <img alt="" className="size-10px" data-testid="medical-item" src={fixedIcon ?? icon} />
      <Text className="flex grow text-sm font-semibold">{title}</Text>
      <OutlinedRightArrowIcon className="size-6px" />
    </button>
  );
};

export default MedicalItemCard;
